<div class="dialog dialog--template-text">
  <header mat-dialog-title class="dialog__header modal-header pl-4 pr-4">
    <span>Template Text</span>
    <button type="button" class="close close-btn" mat-dialog-close><i class="fa fa-close fa-md"></i></button>
  </header>
  <mat-dialog-content>
    <section class="dialog__content">
      <div *ngIf="templateText" [innerHTML]="templateText"></div>
      <footer class="form__footer">
        <button type="button"
                class="flat-butt flat-danger-butt flat-danger-grad-butt"
                (click)="copyToClipboard()"
        >
          Copy Template
        </button>
        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt" mat-dialog-close>Close</button>
      </footer>
    </section>
  </mat-dialog-content>
</div>
